<ion-content class="container">
  <ion-row class="p-0  headerBreadcrumb">
    <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="center-content">
      <div class="d-flex headerBreadcrumb">
        <img src="././assets/icon/backArrow.svg" class="cp" (click)="onClickSetup('Setup')">
        <label class="font_semibold fs-16 ml-10 mt-5 black_color">
          <span class="cp" (click)="onClickSetup('Setup')">Increment / Setup</span> / <span
            [style.color]="buttonColorName">Increment Letter</span></label>
      </div>
    </ion-col>
  </ion-row>
   <div class="modal-body p-20">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <mat-form-field class="w-150 mat-height40 mat-input-style">
          <mat-select placeholder="Select Year" [(ngModel)]="selectedYear" (selectionChange)="onYearChange($event)" >
            <mat-option [value]="item.year" *ngFor="let item of getIncrementFyYearList" >{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
          </mat-select>
        </mat-form-field>
      </ion-col> 
    </ion-row>

    <ion-row>
      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
        <p class="Company-Letter-head-title">Company Letter head</p>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
        <div class="cardBox mb-20 p-20">
            <button class="downloadImportFileBtn font_medium mr-30 mt-10" [style.background-color]="buttonColorName" (click)="onClickDownloadLetterHeadFile()">
              <img class="mr-10" src="././assets/icon/downloadWhite.svg">Letter Head Download</button>
            <div *ngIf="!showBrowseBtn" class="w-100 upload-box display-center pt-25 pb-25 mt-20 cp"
              (click)="browseImage.click()">
              <div class="d-flex text-center">
                <label class="uploadBtn text_center font_regular cp"><span class="material-icons">upload_file</span><br>Browse File</label>
                <input #browseImage type="file" (change)="onFileSelected($event)" style="display:none;">
              </div>
            </div>
            <div *ngIf="showBrowseBtn" class="w-100 upload-box display-center pt-25 pb-25 mt-20 cp">
              <div class="d-flex mb-50 mt-50">
                <div class="verticle-center mr-20">
                  <img src="././assets/icon/successImport.svg">
                </div>
                <div class="flex-column">
                  <label class="fs-14 font_medium text_gray1 mb-10">File Uploaded Successfully.</label>
                  <div class="d-flex">
                    <label class="fs-12 blue font_medium cl-black mx-width">{{fileName}}</label>
                    <span class="material-icons fs-12 ml-5" (click)="onCloseFile()" *ngIf="isDisabledImportLetter">close</span>
                  </div>
                </div>
              </div>
          </div>
          <div class="upload-file-validation">
              <p>One file only | 10 MB Limits</p>
              <button type="button" [style.background-color]="buttonColorName" [disabled]="isDisabledLetterHeadBtn" (click)="onSendCompanyLetterheadFile()">Save</button>
          </div>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
        <p class="select-combination">Select the combination for Increment letters</p>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
        <div class="select-combination-checkbox">
          <section class="mat-checkbox-style">
            <mat-checkbox [(ngModel)]="departmentChecked">Department</mat-checkbox>
            <mat-checkbox [(ngModel)]="bandChecked">Band</mat-checkbox>
            <mat-checkbox [(ngModel)]="ratingChecked">Rating</mat-checkbox>
          </section>
            <button class="create-btn" [style.background-color]="buttonColorName" (click)="onClickCreateBtn()">Create</button>
        </div>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="isIncrementLetterCreateContent" >
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="table-container">

          <!-- only Department -->
          <table class="rating-table" *ngIf="onVisibleDepartmentData">
            <thead>
              <tr>
                <th>Department</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of getDepartmentTableData; let rowId = index">
                <td class="pl-10">{{data}}</td>
                  <td >  
                    <div class="rating-table-data">
                      <u (click)="onClickAddLetter(rowId, '', data, '', '', letterNames[rowId])">
                        {{ letterNames[rowId] && letterNames[rowId][0] ? letterNames[rowId][0] : '+ Add Letter' }}
                      </u>
                     <div>
                      <span *ngIf="letterNames[rowId]" (click)="removeLetter(rowId, 0, 0, letterNames[rowId])" class="fs-16 mr-10 material-icons">close</span>
                      <span class="fs-20 material-icons rating-table-data-icon" [matMenuTriggerFor]="menu">keyboard_arrow_down</span>
                     </div>
                    </div>
                    <mat-menu class="mr-30" #menu="matMenu" (closed)="onMenuClose()">
                      <div class="p-10 center-content" *ngFor="let letter of getIncrementLetterData">
                      <ion-row>
                      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12"  (click)="selectLetter(rowId, letter)">
                      <span class="blue cp">{{ letter.letterName }}</span>
                      </ion-col>
                      </ion-row>
                      </div>
                      </mat-menu>
                  </td>
                </tr>
            </tbody>
          </table>

          <!-- only Band -->
           <table class="rating-table" *ngIf="onVisibleBandData" >
            <thead>
              <tr>
                <th>Band</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of getBandTableData; let rowId = index">
                <td>
                  <div class="band-table-data pl-10">{{data}}</div>
                </td>
                  <td >  
                    <div class="rating-table-data">
                      <u (click)="onClickAddLetter(rowId, '', '', 'data', '', letterNames[rowId])">
                        {{ letterNames[rowId] && letterNames[rowId][0] ? letterNames[rowId][0] : '+ Add Letter' }}
                      </u>
                      <div>
                        <span *ngIf="letterNames[rowId]" (click)="removeLetter(rowId, 0, 0, letterNames[rowId])" class="fs-16 mr-10 material-icons">close</span>
                        <span class="fs-20 material-icons rating-table-data-icon" [matMenuTriggerFor]="menu">keyboard_arrow_down</span>
                      </div> 
                    </div>
                    <mat-menu class="mr-30" #menu="matMenu" (closed)="onMenuClose()">
                      <div class="p-10 center-content" *ngFor="let letter of getIncrementLetterData">
                      <ion-row>
                      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12"  (click)="selectLetter(rowId, letter)">
                      <span class="blue cp">{{ letter.letterName }}</span>
                      </ion-col>
                      </ion-row>
                      </div>
                    </mat-menu>
                  </td>
              </tr>
            </tbody>
           </table>
           
           <!-- only Rating -->
            <table class="rating-table" *ngIf="onVisibleRatingsData">
              <thead>
                <tr>
                  <th *ngFor="let data of getRatingTableData" class="fs-14 font_bold cl-black">{{data.rating | titlecase}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td *ngFor="let data of getRatingTableData; let colId = index">  
                    <div class="rating-table-data">
                      <u (click)="onClickAddLetter(0, colId, '', '', data.ratingId, letterNames[colId])">
                          {{ letterNames[0] && letterNames[0][colId] ? letterNames[0][colId] : '+ Add Letter' }}
                      </u>
                      <div>
                        <span *ngIf="letterNames[0] && letterNames[0][colId]" 
                        (click)="removeLetter(0, 0, colId, letterNames[0][colId])" 
                        class="fs-16 mr-10 material-icons">close</span>
                        <span class="fs-20 material-icons rating-table-data-icon" [matMenuTriggerFor]="menu">keyboard_arrow_down</span>
                      </div>
                    </div>
                    <mat-menu class="mr-30" #menu="matMenu" (closed)="onMenuClose()">
                      <div class="p-10 center-content" *ngFor="let letter of getIncrementLetterData">
                      <ion-row>
                      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" (click)="selectRatingLetter(0, colId, letter)">
                      <span class="blue cp">{{ letter.letterName }}</span>
                      </ion-col>
                      </ion-row> 
                      </div>
                      </mat-menu>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- <table class="rating-table" *ngIf="onVisibleRatingsData">
              <thead>
                <tr>
                  <th *ngFor="let data of getRatingTableData" class="fs-14 font_bold cl-black">
                    {{ data.rating | titlecase }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td *ngFor="let data of getRatingTableData; let colId = index">
                    <div class="rating-table-data">
                      <u (click)="onCLickLetterSave(data.incrementLetterTemplateId?.letterName, data.incrementLetterTemplateId?.subject,
                      data.incrementLetterTemplateId?.body, '', '', data.ratingId, data.id)">
                          {{data.incrementLetterTemplateId?.letterName || '+ Add Letter'}}
                      </u>
                      <span class="fs-20 material-icons" [matMenuTriggerFor]="menu">keyboard_arrow_down</span>
                    </div>
                    <mat-menu class="mr-30" #menu="matMenu" (closed)="onMenuClose()">
                      <div class="p-10 center-content" *ngFor="let letter of getRatingTableData">
                        <ion-row>
                          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" 
                            (click)="selectRatingLetter(0, colId, letter)">
                            <span class="blue cp">{{letter.incrementLetterTemplateId?.letterName}}</span>
                          </ion-col>
                        </ion-row>
                      </div>
                    </mat-menu>
                  </td>
                </tr>
              </tbody>
            </table> -->
            

          <!-- Department and Band -->
          <table class="rating-table" *ngIf="onVisibleDepartmentAndBandData">
            <thead>
              <tr>
                <th>Department</th>
                <th>Band</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <!-- <ng-container *ngFor="let data of getDepartmentAndBandTableData; let rowId = index">
                <tr *ngFor="let band of data.bands; let colId = index">
                  <td *ngIf="colId === 0" [attr.rowspan]="data.bands.length" class="pl-10">{{ data.department }}</td>
                  <td class="pl-10">{{ band }}</td>
                  <td>
                    <div class="rating-table-data">
                      <u (click)="onClickAddLetter(rowId, colId, data.department, band, '')">
                        {{ letterNames[rowId] && letterNames[rowId][colId] ? letterNames[rowId][colId] : '+ Add Letter' }}
                      </u>
                      <div>
                        <span *ngIf="letterNames[rowId]" (click)="removeLetter(rowId, colId, letterNames[rowId])" class="fs-16 mr-10 material-icons">close</span>
                        <span class="fs-20 material-icons rating-table-data-icon" [matMenuTriggerFor]="menu">keyboard_arrow_down</span>
                      </div>
                    </div>
                    <mat-menu class="mr-30" #menu="matMenu" (closed)="onMenuClose()">
                      <div class="p-10 center-content" *ngFor="let letter of getIncrementLetterData">
                      <ion-row>
                      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" (click)="selectRatingLetter(rowId, colId, letter)">
                      <span class="blue cp">{{ letter.letterName }}</span>
                      </ion-col>
                      </ion-row>
                      </div>
                      </mat-menu>
                  </td>
                </tr>
              </ng-container> -->
              <ng-container *ngFor="let data of getDepartmentAndBandTableData; let rowId = index">
                <tr *ngFor="let band of data.bands; let colId = index">
                  <td *ngIf="colId === 0" [attr.rowspan]="data.bands.length" class="pl-10">{{ data.department }}</td>
                  <td class="pl-10">{{ band }}</td>
                  <td>
                    <div class="rating-table-data">
                      <u (click)="onClickAddLetter(rowId, colId, data.department, band, '', letterNames[rowId]?.[colId])">
                        {{ letterNames[rowId] && letterNames[rowId][colId] ? letterNames[rowId][colId] : '+ Add Letter' }}
                      </u>
                      <div>
                        <span *ngIf="letterNames[rowId] && letterNames[rowId][colId]" (click)="removeLetter(rowId, 0, colId, letterNames[rowId][colId])" class="fs-16 mr-10 material-icons">close</span>
                        <span class="fs-20 material-icons rating-table-data-icon" [matMenuTriggerFor]="menu">keyboard_arrow_down</span>
                      </div>
                    </div>
                    <mat-menu class="mr-30" #menu="matMenu" (closed)="onMenuClose()">
                      <div class="p-10 center-content" *ngFor="let letter of getIncrementLetterData">
                        <ion-row>
                          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" 
                                   (click)="selectRatingLetter(rowId, colId, letter)">
                            <span class="blue cp">{{ letter.letterName }}</span>
                          </ion-col>
                        </ion-row>
                      </div>
                    </mat-menu>
                  </td>
                </tr>
              </ng-container>            
            </tbody>
          </table>
          

          <!-- department and rating -->
          <table class="rating-table" *ngIf="onVisibleDepartmentAndRatingData">
            <thead>
              <tr>
                <th>Department</th>
                <th *ngFor="let data of getRatingTableData" class="fs-14 font_bold cl-black">
                  {{ data.rating | titlecase }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let departmentData of getDepartmentTableData; let rowId = index">
                <td class="pl-10">{{ departmentData }}</td>
                <td *ngFor="let ratingData of getRatingTableData; let colId = index">
                  <div class="rating-table-data">
                    <u (click)="onClickAddLetter(rowId, colId, departmentData, '', ratingData.ratingId, letterNames[rowId]?.[colId])">
                      {{ letterNames[rowId] && letterNames[rowId][colId] ? letterNames[rowId][colId] : '+ Add Letter' }}
                    </u>
                    <div>
                      <span *ngIf="letterNames && letterNames[rowId] && letterNames[rowId][colId]" (click)="removeLetter(rowId, 0, colId, letterNames[rowId][colId])" class="fs-16 mr-10 material-icons">close</span>
                      <span class="fs-20 material-icons rating-table-data-icon" [matMenuTriggerFor]="menu">keyboard_arrow_down</span>
                    </div>
                  </div>
                  <mat-menu class="mr-30" #menu="matMenu" (closed)="onMenuClose()">
                    <div class="p-10 center-content" *ngFor="let letter of getIncrementLetterData">
                    <ion-row>
                    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" (click)="selectRatingLetter(rowId, colId, letter)">
                    <span class="blue cp">{{ letter.letterName }}</span>
                    </ion-col>
                    </ion-row>
                    </div>
                    </mat-menu>
                </td>
              </tr>
            </tbody>
          </table>
          
          
          <!-- band and rating -->
          <table class="rating-table" *ngIf="onVisibleBandAndRatingData">
            <thead>
              <tr>
                <th>Band</th>
                <th *ngFor="let data of getRatingAndBandTableData" class="fs-14 font_bold cl-black">{{data.rating | titlecase}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of getBandAndRatingTableData; let rowId = index"> 
                <td class="pl-10">{{data}}</td>
                  <td *ngFor="let ratingdata of getRatingAndBandTableData; let colId = index">  
                    <div class="rating-table-data">
                      <u (click)="onClickAddLetter(rowId, colId, '', data, ratingdata.id, letterNames[rowId]?.[colId])">
                        {{ letterNames[rowId] && letterNames[rowId][colId] ? letterNames[rowId][colId] : '+ Add Letter' }}
                      </u>
                      <div>
                        <span  *ngIf="letterNames && letterNames[rowId] && letterNames[rowId][colId]" (click)="removeLetter(rowId, 0, colId, letterNames[rowId][colId])" class="fs-16 mr-10 material-icons">close</span>
                        <span class="fs-20 material-icons rating-table-data-icon" [matMenuTriggerFor]="menu">keyboard_arrow_down</span>
                      </div>
                    </div>
                    <mat-menu class="mr-30" #menu="matMenu" (closed)="onMenuClose()">
                      <div class="p-10 center-content" *ngFor="let letter of getIncrementLetterData">
                      <ion-row>
                      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" (click)="selectRatingLetter(rowId, colId, letter)">
                      <span class="blue cp">{{ letter.letterName }}</span>
                      </ion-col>
                      </ion-row>
                      </div>
                      </mat-menu>
                  </td> 
              </tr>
            </tbody>
          </table>

           <!-- department and band and rating -->
           <!-- <table class="rating-table" *ngIf="onVisibleDepartmentAndBandAndRatingData">
            <thead>
            <tr>
            <th>Department</th>
            <th>Band</th>
            <th *ngFor="let data of getRatingTableData" class="fs-14 font_bold cl-black">{{data.rating | titlecase}}</th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngFor="let data of getDepartmentAndBandTableData; let rowId = index">
            <tr *ngFor="let band of data.bands; let i = index">
            <td *ngIf="i === 0" [attr.rowspan]="data.bands.length" class="pl-10">{{data.department}}</td>
            <td class="pl-10">{{band}}</td>
            <td *ngFor="let rating of getRatingTableData; let colId = index">
            <div class="rating-table-data">
            <u (click)="onClickAddLetter(rowId, colId, data.department, band, rating.ratingId)">
            {{ letterNames[rowId] && letterNames[rowId][colId] ? letterNames[rowId][colId] : '+ Add Letter' }}
            </u>
            <div>
              <span  *ngIf="letterNames && letterNames[rowId] && letterNames[rowId][colId]" (click)="removeLetter(rowId, colId, letterNames[rowId][colId])" class="fs-16 mr-10 material-icons">close</span>
              <span class="fs-20 material-icons rating-table-data-icon" [matMenuTriggerFor]="menu">keyboard_arrow_down</span>
            </div>
            </div>
            <mat-menu class="mr-30" #menu="matMenu" (closed)="onMenuClose()">
            <div class="p-10 center-content" *ngFor="let letter of getIncrementLetterData">
            <ion-row>
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" (click)="selectRatingLetter(rowId, colId, letter)">
            <span class="blue cp">{{ letter.letterName }}</span>
            </ion-col>
            </ion-row>
            </div>
            </mat-menu>
            </td>
            </tr>
            </ng-container>
            </tbody>
            </table> -->

            <table class="rating-table" *ngIf="onVisibleDepartmentAndBandAndRatingData">
              <thead>
                <tr>
                  <th>Department</th>
                  <th>Band</th>
                  <th *ngFor="let data of getRatingTableData" class="fs-14 font_bold cl-black">{{ data.rating | titlecase }}</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let data of getDepartmentAndBandTableData; let rowId = index">
                  <tr *ngFor="let band of data.bands; let i = index">
                    <td *ngIf="i === 0" [attr.rowspan]="data.bands.length" class="pl-10">{{ data.department }}</td>
                    <td class="pl-10">{{ band }}</td>
                    <td *ngFor="let rating of getRatingTableData; let colId = index">
                      <div class="rating-table-data">
                        <u (click)="onClickAddDeptBandRatingLetter(rowId, i, colId, data.department, band, rating.ratingId, letterNames[rowId]?.[i]?.[colId])">
                          {{ letterNames[rowId] && letterNames[rowId][i] && letterNames[rowId][i][colId] ? letterNames[rowId][i][colId] : '+ Add Letter' }}
                        </u>
                        <div>
                          <span *ngIf="letterNames && letterNames[rowId] && letterNames[rowId][i] && letterNames[rowId][i][colId]"
                                (click)="removeLetter(rowId, i, colId, letterNames[rowId][i][colId])" 
                                class="fs-16 mr-10 material-icons">close</span>
                          <span class="fs-20 material-icons rating-table-data-icon" [matMenuTriggerFor]="menu">keyboard_arrow_down</span>
                        </div>
                      </div>
                      <mat-menu class="mr-30" #menu="matMenu" (closed)="onMenuClose()">
                        <div class="p-10 center-content" *ngFor="let letter of getIncrementLetterData">
                          <ion-row>
                            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" (click)="selectDeptAndBandAndRatingLetter(rowId, i, colId, letter)">
                              <span class="blue cp">{{ letter.letterName }}</span>
                            </ion-col>
                          </ion-row>
                        </div>
                      </mat-menu>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
        </div>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="isIncrementLetterCreateContent">
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <p class="promotion-content">Promotion Content</p>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="isIncrementLetterCreateContent">
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <mat-form-field class="w-100  mat-input-style">
          <textarea matInput [(ngModel)]="IncrementLetterPromotionContent" placeholder="Description"
           rows="5"></textarea>
        </mat-form-field>
        <label *ngIf="isInValidIncrementLetterDescription" class="red-cl font_regular fs-12">
          Enter Description
        </label>
      </ion-col> 
    </ion-row>
    </div> 

    <div class="modal-footer" *ngIf="isIncrementLetterCreateContent">
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="footer-btn-group">
              <button class="cancleBtn" (click)="onClickCancleBtn()">Cancle</button>
              <button class="saveBtn" [style.background-color]="buttonColorName" (click)="onClickIncrementLetterSave()" [disabled]="isDisabledIncrementLetter"
              [ngClass]="{ 'disable': isDisabledIncrementLetter }">Save</button>
            </div>
        </ion-col>
      </ion-row>
    </div>
</ion-content>